"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _oxygenConstants = require("@8x8/oxygen-constants");

var _groupAlign = require("../constants/groupAlign");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function getMarginLeft(_ref) {
  var spacing = _ref.spacing,
      hasHorizontalSpacing = _ref.hasHorizontalSpacing;

  if (!hasHorizontalSpacing) {
    return null;
  }

  var marginLeft = spacing === _oxygenConstants.buttonSize.big ? _oxygenConstants.button.marginLeftLarge : _oxygenConstants.button.marginLeftSmall;
  return "margin-left: ".concat(marginLeft);
}

function getMarginBottom(_ref2) {
  var spacing = _ref2.spacing,
      hasVerticalSpacing = _ref2.hasVerticalSpacing;

  if (!hasVerticalSpacing) {
    return null;
  }

  var marginBottom = spacing === _oxygenConstants.buttonSize.big ? _oxygenConstants.button.marginBottomLarge : _oxygenConstants.button.marginBottomSmall;
  return "margin-bottom: ".concat(marginBottom);
}

var ButtonGroupWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  text-align: ", ";\n\n  > *:not(:first-child) {\n    ", ";\n  }\n\n  > * {\n    ", ";\n  }\n"])), function (_ref3) {
  var align = _ref3.align;
  return align;
}, getMarginLeft, getMarginBottom);

ButtonGroupWrapper.propTypes = {
  /**
   * ButtonGroup content
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].node]).isRequired,

  /**
   * Spacing between the buttons in ButtonGroup ('small', 'big')
   */
  spacing: _propTypes["default"].oneOf([_oxygenConstants.buttonSize.small, _oxygenConstants.buttonSize.big]),

  /**
   * Content alignment ('left', 'center', 'right')
   */
  align: _propTypes["default"].oneOf([_groupAlign.LEFT, _groupAlign.CENTER, _groupAlign.RIGHT]),

  /**
   * Represents if the button group has horizontal spacing (default: true)
   */
  hasHorizontalSpacing: _propTypes["default"].bool,

  /**
   * Represents if the button group has vertical spacing (default: false)
   */
  hasVerticalSpacing: _propTypes["default"].bool
};
ButtonGroupWrapper.defaultProps = {
  spacing: _oxygenConstants.buttonSize.big,
  align: _groupAlign.CENTER,
  hasHorizontalSpacing: true,
  hasVerticalSpacing: false
};
var _default = ButtonGroupWrapper;
exports["default"] = _default;